import { CheckTextSelect, FormClassRetire } from "../../assets/data/Constants";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const retireeStepper = [
  "退職者確認",
  "請求者の確認",
  "請求者情報の登録",
  "振込先金融機関の登録",
  "本人確認の書類の添付",
  "退職所得の受給に関する申告書の登録",
  "源泉徴収票の確認",
  "申告書兼退職所得申告書の作成",
  "退職所得情報登録",
  "登録内容の確認",
  "機構へ提出",
];

// 相続人
const heirStepper = [
  "退職者確認",
  "請求者の確認",
  "請求者情報の登録",
  "振込先金融機関の登録",
  "添付書類の登録",
  "本人確認の書類の添付",
  "退職所得の受給に関する申告書の登録",
  "源泉徴収票の確認",
  "申告書兼退職所得申告書の作成",
  "退職所得情報登録",
  "登録内容の確認",
  "機構へ提出",
];

// 遺族
const bereavedStepper = [
  "退職者確認",
  "請求者の確認",
  "請求者情報の登録",
  "振込先金融機関の登録",
  "添付書類の登録",
  "本人確認の書類の添付",
  "退職所得の受給に関する申告書の登録",
  "登録内容の確認",
  "機構へ提出",
];

const infoManual = `
    退職手当金の請求にあたって、次の書類の添付が必要となります。<
    ・本人であることを確認するための書類<
    ・個人番号を確認できる書類<
    ・振込先口座が確認できる書類<
    次の表に記載の内容をアップロードし、「次へ」ボタンを押してください。`;

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "確認する書類の選択",
    keyword: "identificationDocsKind",
    type: "selectForm",
    selectPropsList: TkGetCodeList(CheckTextSelect),
    requiredIcon: true,
  },
  {
    title: "本人であることを確認するための書類",
    keyword: "identification1",
    type: "fileUpload",
    requiredIcon: true,
    helpicon: true,
    helpText: (
      <>
        次の①～⑤のいずれかの書類の写しを添付してください。
        <br />
        ①個人番号カード（顔写真のある面）、②運転免許証（表裏）、③運転経歴証明書、④パスポート、⑤健康保険証、年金手帳、公共料金の領収書の中から２種類
      </>
    ),
    showLine: false,
    id: FormClassRetire["本人確認書類"],
  },
  {
    title: "本人であることを確認するための書類",
    keyword: "identification2",
    type: "fileUpload",
    requiredIcon: true,
    helpicon: true,
    helpText: (
      <>
        次の①～⑤のいずれかの書類の写しを添付してください。
        <br />
        ①個人番号カード（顔写真のある面）、②運転免許証（表裏）、③運転経歴証明書、④パスポート、⑤健康保険証、年金手帳、公共料金の領収書の中から２種類
      </>
    ),
    showLine: false,
    id: +FormClassRetire["本人確認書類"] + 100 + "",
  },
  {
    title: "本人であることを確認するための書類（表面）",
    keyword: "identificationFront",
    type: "fileUpload",
    requiredIcon: true,
    helpicon: true,
    helpText: (
      <>
        次の①～⑤のいずれかの書類の写しを添付してください。
        <br />
        ①個人番号カード（顔写真のある面）、②運転免許証（表裏）、③運転経歴証明書、④パスポート、⑤健康保険証、年金手帳、公共料金の領収書の中から２種類
      </>
    ),
    showLine: false,
    id: FormClassRetire["本人確認書類（表面）"],
  },
  {
    title: "本人であることを確認するための書類（裏面）",
    keyword: "identificationBack",
    type: "fileUpload",
    requiredIcon: true,
    helpicon: true,
    helpText: (
      <>
        次の①～⑤のいずれかの書類の写しを添付してください。
        <br />
        ①個人番号カード（顔写真のある面）、②運転免許証（表裏）、③運転経歴証明書、④パスポート、⑤健康保険証、年金手帳、公共料金の領収書の中から２種類
      </>
    ),
    showLine: false,
    id: FormClassRetire["本人確認書類（裏面）"],
  },
  {
    title: "死亡した退職者の個人番号を確認する書類",
    keyword: "myNumberOfDeceased",
    type: "fileUpload",
    requiredIcon: true,
    showLine: false,
    id: FormClassRetire["死亡した退職者の個人番号を確認する書類"],
  },
  {
    title: "旧姓と新姓が確認できる住民票",
    keyword: "nameConfirmation",
    type: "fileUpload",
    requiredIcon: true,
    helpicon: true,
    helpText: (
      <>
        次のいずれか１つを選んでください。
        <br />
        ①運転免許証（表裏）、②戸籍抄本、③旧姓と新姓が確認できる住民票
      </>
    ),
    showLine: false,
    id: FormClassRetire["旧姓と新姓が確認できる住民票"],
  },
  {
    title: "個人番号を確認する書類",
    keyword: "myNumber",
    type: "fileUpload",
    requiredIcon: true,
    requiredText: "法律で定められた義務",
    helpicon: true,
    helpText: (
      <>
        次のいずれか１つを選んでください。
        <br />
        ①個人番号カード（個人番号がある面）、②番号通知カード（表示されている氏名、住所に変更がない場合のみ有効です）、③個人番号が記載された住民票
      </>
    ),
    showLine: false,
    id: FormClassRetire["個人番号を確認する書類"],
  },
  {
    title: "振込先口座が確認できる書類",
    keyword: "bankAccount",
    type: "fileUpload",
    requiredIcon: true,
    helpicon: true,
    helpText: (
      <>
        次の①～③のいずれかの書類の写しを添付してください。
        <br />
        ①通帳の「表紙」と「見開きページ」、②キャッシュカードの写し（金融機関名、支店番号、口座番号、口座名義のある面）※クレジットカード機能付きの場合は、クレジットカードの番号を伏せて登録してください。、③インターネットバンキングなど通帳がない場合は、WEB上の口座情報が確認できるページなど、振込先口座が確認できるもの
      </>
    ),
    showLine: false,
    id: FormClassRetire["振込先口座が確認できる書類"],
  },
];

const schema = {
  documentType: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  identification1: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  identification2: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  identificationFront: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  identificationBack: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  myNumberOfDeceased: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  nameConfirmation: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  bankAccount: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

const schemaAnyTime = {
  identificationDocsKind: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

const schema1 = {
  documentType: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  identification1: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  myNumberOfDeceased: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  nameConfirmation: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  bankAccount: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

const schema1_1 = {
  documentType: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  identification1: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  nameConfirmation: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  bankAccount: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

const schema2 = {
  documentType: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  identificationFront: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  identificationBack: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  myNumberOfDeceased: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  nameConfirmation: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  bankAccount: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

const schema2_1 = {
  documentType: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  identificationFront: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  identificationBack: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  nameConfirmation: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  bankAccount: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

const schema3 = {
  documentType: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  identification1: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  identification2: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  myNumberOfDeceased: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  nameConfirmation: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  bankAccount: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

const schema3_1 = {
  documentType: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  identification1: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  identification2: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  nameConfirmation: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  bankAccount: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

export {
  retireeStepper,
  heirStepper,
  bereavedStepper,
  infoManual,
  fakeTableList,
  schema,
  schema1_1,
  schema1,
  schema2_1,
  schema2,
  schema3,
  schema3_1,
  schemaAnyTime,
};
